import { defineComponent as _defineComponent } from 'vue'
import { Trade, Individual } from 'ah-api-gateways';
import { useRequestManager } from 'ah-common-lib/src/requestManager/useRequestManager';
import { computed, reactive, watch } from 'vue';
import { useAhTradesState } from '../..';


export default /*#__PURE__*/_defineComponent({
  __name: 'TradeOnBehalfOfInfo',
  props: {
    trade: null
  },
  setup(__props: any) {

const props = __props as {
  trade: Trade;
};

const tradeState = useAhTradesState();



const requestManager = useRequestManager({
  exposeToParent: ['getAgentInformation'],
  onRetryFromParentManager: (k: string) => {
    if (k === 'getAgentInformation') {
      onTradeChange();
    }
  },
});

const state = reactive({
  oboCreator: null as Individual | null,
});

const needsIndividualInformation = computed(() => {
  return !props.trade.oboCreatedByName && !props.trade.oboCreatedByEmail;
});

const partnerName = computed(() => {
  return state.oboCreator?.partner?.name || state.oboCreator?.email || null;
});

function onTradeChange() {
  state.oboCreator = null;
  if (props.trade.oboCreatedByIndividualId && needsIndividualInformation.value) {
    requestManager.manager
      .currentOrNew(
        'getAgentInformation',
        tradeState.services.individual.getIndividual(props.trade.oboCreatedByIndividualId!, {
          errors: { silent: true },
        })
      )
      .subscribe((oboCreator) => {
        state.oboCreator = oboCreator;
      });
  }
}

watch(
  () => props.trade,
  () => {
    onTradeChange();
  },
  { immediate: true }
);

return { __sfc: true,tradeState, props, requestManager, state, needsIndividualInformation, partnerName, onTradeChange }
}

})